jQuery(document).ready(function() {

    // toggle filter groups
    $('.filters .filter .filter__toggle').click( function(e) {
        e.preventDefault();
        var $filter = $(this).closest('.filter');

        if( $filter.hasClass('filter--collapsed') ) {
            $filter.removeClass('filter--collapsed');
            $(this).next('.filter__body').stop().slideDown( 150, 'easeInOutCubic' );
        } else {
            $filter.addClass('filter--collapsed');
            $(this).next('.filter__body').stop().slideUp( 150, 'easeInOutCubic' );
        }
    });


    // collapse filters on pageload that have class .filter-collapsed
    $('.filters .filter.filter--collapsed').each( function() {
        $(this).find('.filter__body').stop().slideUp( 150, 'easeInOutCubic' );
    });


    // collapse filters on pageload when on mobile
    if( $(window).width() < 992 ) {
        $('.filters .filter').each( function() {
            if( !$(this).hasClass('filter--collapsed') ) {
                $(this).addClass('filter--collapsed');
                $(this).find('.filter__body').stop().slideUp( 150, 'easeInOutCubic' );
            }
        });
    }

});